import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <div className="privacy-container">
        <div className="privacy-header">
          <button className="back-btn" onClick={() => navigate('/')}>
            ← Ana Sayfaya Dön
          </button>
          <h1>Kullanım Koşulları</h1>
          <p>Son güncelleme: 1 Ocak 2025</p>
        </div>

        <div className="privacy-content">
          <section>
            <h2>1. Genel Hükümler</h2>
            <p>
              Bu kullanım koşulları, Taxicim uygulaması ve web sitesini kullanarak 
              kabul etmiş olduğunuz şartları içermektedir. Uygulamamızı kullanmadan 
              önce lütfen bu koşulları dikkatlice okuyunuz.
            </p>
          </section>

          <section>
            <h2>2. Tanımlar</h2>
            <ul>
              <li><strong>Taxicim:</strong> Mobil uygulama ve web platformu</li>
              <li><strong>Kullanıcı:</strong> Yolcu ve sürücü kullanıcıları</li>
              <li><strong>Hizmet:</strong> Taksi çağırma ve ulaşım hizmetleri</li>
              <li><strong>Platform:</strong> Taxicim uygulaması ve web sitesi</li>
            </ul>
          </section>

          <section>
            <h2>3. Hizmet Kapsamı</h2>
            <p>
              Taxicim, kullanıcıların taksi hizmeti almasını sağlayan bir platform hizmetidir. 
              Şirketimiz aracılık hizmeti sunmakta olup, taşıma hizmeti bağımsız taksi 
              şoförleri tarafından sağlanmaktadır.
            </p>
          </section>

          <section>
            <h2>4. Kullanıcı Yükümlülükleri</h2>
            <h3>4.1 Genel Yükümlülükler:</h3>
            <ul>
              <li>Doğru ve güncel bilgi sağlamak</li>
              <li>Platforma zarar verecek faaliyetlerde bulunmamak</li>
              <li>Diğer kullanıcılara saygılı davranmak</li>
              <li>Yasal düzenlemelere uymak</li>
              <li>Fikri mülkiyet haklarına saygı göstermek</li>
            </ul>

            <h3>4.2 Yolcu Yükümlülükleri:</h3>
            <ul>
              <li>Zamanında belirlenen noktada hazır bulunmak</li>
              <li>Sürücüye saygılı davranmak</li>
              <li>Araç içinde kurallara uymak</li>
              <li>Ücretini ödemek</li>
              <li>İptal politikalarına uymak</li>
            </ul>

            <h3>4.3 Sürücü Yükümlülükleri:</h3>
            <ul>
              <li>Geçerli ehliyet ve izinlere sahip olmak</li>
              <li>Araç bakım ve güvenlik standartlarını sağlamak</li>
              <li>Güvenli sürüş yapmak</li>
              <li>Yolculara saygılı davranmak</li>
              <li>Platform kurallarına uymak</li>
            </ul>
          </section>

          <section>
            <h2>5. Ücretlendirme ve Ödeme</h2>
            <ul>
              <li>Ücretler uygulama içinde belirtilir</li>
              <li>Ödeme yöntemleri: nakit, kredi kartı, mobil ödeme</li>
              <li>Komisyon oranları sürücü sözleşmesinde belirtilir</li>
              <li>İptal ücretleri geçerli olabilir</li>
              <li>Fatura talebinde bulunabilirsiniz</li>
            </ul>
          </section>

          <section>
            <h2>6. İptal ve İade Politikası</h2>
            <p>
              <strong>Yolcu İptalleri:</strong>
            </p>
            <ul>
              <li>Sürücü atanmadan önce: Ücretsiz iptal</li>
              <li>Sürücü atandıktan sonra ilk 2 dakika: Ücretsiz iptal</li>
              <li>2 dakika sonrası: İptal ücreti uygulanır</li>
            </ul>

            <p>
              <strong>Sürücü İptalleri:</strong>
            </p>
            <ul>
              <li>Geçerli sebeplerle iptal edilebilir</li>
              <li>Sık iptal durumunda hesap incelemesi yapılır</li>
            </ul>
          </section>

          <section>
            <h2>7. Güvenlik ve Emniyet</h2>
            <ul>
              <li>Tüm sürücüler kimlik doğrulamasından geçer</li>
              <li>Acil durum butonu mevcuttur</li>
              <li>Yolculuklar GPS ile takip edilir</li>
              <li>Şüpheli durumlar rapor edilebilir</li>
              <li>7/24 müşteri desteği sağlanır</li>
            </ul>
          </section>

          <section>
            <h2>8. Kişisel Verilerin Korunması</h2>
            <p>
              Kişisel verileriniz KVKK uyarınca korunmaktadır. 
              Detaylı bilgi için Gizlilik Politikamızı inceleyiniz.
            </p>
          </section>

          <section>
            <h2>9. Fikri Mülkiyet Hakları</h2>
            <p>
              Taxicim uygulaması ve içeriği fikri mülkiyet haklarıyla korunmaktadır. 
              İzinsiz kullanım, kopyalama veya dağıtım yasaktır.
            </p>
          </section>

          <section>
            <h2>10. Hesap Askıya Alma ve Sonlandırma</h2>
            <p>
              Aşağıdaki durumlarda hesabınız askıya alınabilir veya sonlandırılabilir:
            </p>
            <ul>
              <li>Kullanım koşullarının ihlali</li>
              <li>Hileli faaliyetler</li>
              <li>Diğer kullanıcılara rahatsızlık verme</li>
              <li>Yasal olmayan faaliyetler</li>
              <li>Çoklu hesap kullanımı</li>
            </ul>
          </section>

          <section>
            <h2>11. Sorumluluk Sınırlaması</h2>
            <p>
              Taxicim bir aracılık platformudur. Ulaşım hizmeti bağımsız sürücüler 
              tarafından sağlanmaktadır. Platform, hizmet kalitesi için makul 
              çaba gösterse de, sürücülerin eylemlerinden doğan zararlardan 
              sınırlı sorumluluğu vardır.
            </p>
          </section>

          <section>
            <h2>12. Şikayet ve Çözüm</h2>
            <p>
              Herhangi bir sorun yaşadığınızda:
            </p>
            <ul>
              <li>Uygulama içi destek sistemini kullanın</li>
              <li>Müşteri hizmetleri ile iletişime geçin</li>
              <li>E-posta: destek@taxicim.com.tr</li>
              <li>Telefon: 08502428876</li>
            </ul>
          </section>

          <section>
            <h2>13. Mücbir Sebepler</h2>
            <p>
              Doğal afetler, savaş, grev, teknik arızalar gibi kontrolümüz 
              dışındaki durumlardan kaynaklanan hizmet kesintilerinden 
              sorumlu değiliz.
            </p>
          </section>

          <section>
            <h2>14. Uygulanacak Hukuk ve Yetki</h2>
            <p>
              Bu sözleşme Türk hukukuna tabidir. Uyuşmazlıklar İstanbul 
              mahkemelerinde çözülecektir.
            </p>
          </section>

          <section>
            <h2>15. Değişiklikler</h2>
            <p>
              Bu kullanım koşulları gerektiğinde güncellenebilir. 
              Önemli değişiklikler uygulama üzerinden bildirilecektir.
            </p>
          </section>

          <section>
            <h2>16. İletişim</h2>
            <p>
              <strong>Şirket:</strong> Taxicim<br/>
              <strong>Adres:</strong> Atatürk Mah. Ertuğrul Gazi Sok. Metropol İstanbul A Blok Apt No:2E Kat:21 Daire:331 Ataşehir / İstanbul<br/>
              <strong>E-posta:</strong> info@taxicim.com.tr<br/>
                              <strong>Telefon:</strong> 08502428876
            </p>
          </section>

          <section>
            <h2>17. Üçüncü Taraf Reklam ve Analiz Araçları</h2>
            <p>
              Taxicim web sitesi ve uygulamasında; Facebook (Meta) Pixel, Google Analytics/Ads, TikTok Pixel gibi üçüncü taraf reklam ve analiz araçları kullanılabilir. Bu araçlar, kullanıcı davranışlarını analiz etmek ve reklamları optimize etmek amacıyla çerezler ve benzeri teknolojilerle veri toplayabilir. Detaylı bilgi için Gizlilik Politikamızı inceleyiniz.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 